const carouselItems = [
  {
    title: '2026暑期韩漫嘉年华',
    desc: '炎炎夏日，窝在家里畅读百部热门韩漫！暑期特别策划专题上线，精选恋爱、奇幻、悬疑三大品类TOP作品，连续30天每日推荐一部宝藏漫画。',
    tag: '特别企划',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20fantasy%20wide%20banner%20art%20featuring%20vast%20magical%20world%20with%20warm%20golden%20lighting%20floating%20colorful%20elements%20cinematic%20composition%20rich%20detail%20atmospheric%20soft%20gradient%20background&width=1200&height=600&seq=carousel-kr-01&orientation=landscape',
  },
  {
    title: '新人必读：韩漫入门指南',
    desc: '刚接触韩漫不知道从哪看起？我们为你整理了10部零门槛入门佳作，从恋爱甜宠到热血冒险，总有一部适合你。每部附带阅读顺序和看点解析。',
    tag: '新人指南',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20warm%20welcoming%20wide%20banner%20art%20featuring%20colorful%20comic%20book%20collection%20displayed%20on%20wooden%20shelf%20with%20warm%20cozy%20lighting%20inviting%20atmosphere%20cinematic%20composition%20soft%20tones&width=1200&height=600&seq=carousel-kr-02&orientation=landscape',
  },
  {
    title: '韩漫改编动画大盘点',
    desc: '你知道吗？这些热门动画都改编自韩国漫画！从《神之塔》到《女神降临》，盘点了近5年所有韩漫改编的动画作品，看看你追过几部？',
    tag: '深度盘点',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20animation%20adaptation%20wide%20banner%20art%20featuring%20colorful%20animated%20style%20characters%20collage%20with%20warm%20coral%20and%20golden%20lighting%20cinematic%20composition%20vibrant%20energetic%20atmosphere&width=1200&height=600&seq=carousel-kr-03&orientation=landscape',
  },
  {
    title: '独家专访：人气画家创作谈',
    desc: '我们邀请到了三位目前最炙手可热的韩国漫画家，分享他们的创作心路、灵感来源以及对中国读者的暖心寄语。精彩内容不容错过！',
    tag: '独家专访',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20artist%20interview%20wide%20banner%20art%20featuring%20artistic%20workspace%20with%20drawing%20tablet%20and%20sketches%20warm%20studio%20lighting%20creative%20atmosphere%20cinematic%20composition%20soft%20golden%20tones&width=1200&height=600&seq=carousel-kr-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度策划的韩漫专题内容，发现更多精彩
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group block bg-background-100 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`韩漫专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}